// extracted by mini-css-extract-plugin
module.exports = {"countryFooterSection":"footerSection-module--country-footer-section--PX_-4"};